import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import type { FC } from 'react';

import type { Integration } from '@core/types/api/Integration/Integration';
import { useEntityDrawer } from '@web/hooks/useEntityDrawer';
import { useSlabMutation } from '@web/hooks/useSlabMutation';

import { IntegrationDrawer } from './IntegrationDrawer';
import { IntegrationList } from './IntegrationList';

type Props = {
  tenantID: string;
};

export const IntegrationsPage: FC<Props> = ({ tenantID }) => {
  const integrationDrawer = useEntityDrawer<Integration>();

  const archiveIntegration = useSlabMutation('POST integration archive as admin');

  return (
    <Box>
      <Box paddingY={3} textAlign='right'>
        <Button
          startIcon={<Add />}
          variant='slab-primary'
          onClick={() => integrationDrawer.present()}
        >
          Add Integration
        </Button>
      </Box>
      <IntegrationList
        editIntegration={integrationDrawer.present}
        archiveIntegration={archiveIntegration.mutate}
        tenantIdOverride={tenantID}
      />
      <IntegrationDrawer
        integration={integrationDrawer.entity}
        isOpen={integrationDrawer.isOpen}
        onDismiss={integrationDrawer.dismiss}
        tenantIdOverride={tenantID}
      />
    </Box>
  );
};
